<template>
  <BaseInput
    v-model="initials"
    :cleave-options="{
      blocks: [3],
      uppercase: true,
      onValueChanged: (event) => {
        initials = event.target.value.replace(/[^a-zA-Z]/g, '')
      }
    }"
    type="text"
    autocomplete="off"
    :validations="v$.initials"
    data-test="initials-input"
    class="i-input small-text"/>
</template>

<script setup>
import BaseInput from '@/components/global/BaseInput.vue'
import useVuelidate from '@vuelidate/core'
import { alpha, maxLength, minLength, requiredIf } from '@vuelidate/validators'
import { watch } from 'vue'

defineOptions({
  compatConfig: {
    COMPONENT_V_MODEL: false
  }
})

const initials = defineModel({
  type: String,
  required: true
})

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  }
})

const validationRules = {
  initials: {
    required: requiredIf(() => props.required),
    alpha,
    minLength: minLength(2),
    maxLength: maxLength(3)
  }
}
const v$ = useVuelidate(validationRules, { initials })

const emit = defineEmits({ valid: (value) => typeof value === 'boolean' })
watch(() => v$.value.$invalid, (invalid) => {
  emit('valid', !invalid)
})
</script>

<style lang="scss" scoped>
// Avoid using the word 'initial' in the class name so
// extensions like 1Password don't try to fill it in.
.i-input {
  display: flex;
  align-items: center;
  gap: $spacing-xxs;

  :deep(input) {
    width: 60px !important;
    padding: 0 $spacing-xxs !important;
    text-align: center;
  }
  :deep(div:empty) {
    display: none;
  }
  :deep(.input-group) {
    width: auto;
  }
  :deep(.error-slot) {
    margin: 0;
  }
}
</style>
